import Background from "Components/Atoms/Background/background";
import React from "react";
import { modalToggle } from "Store/Slices/modal";
import { ReactComponent as ModalX } from "Util/svg/modalX.svg";
import { useDispatch } from "react-redux";
import parse from "html-react-parser";
import Quill from "Components/Atoms/Quill/quill";

const PreviewAutoMailModal = ({
  modalNum,
  title,
  content,
  footer,
  imgUrl,
  addImgUrl1,
  addImgUrl2,
  addImgUrl3,
  url1,
  url2,
  url3,
}: {
  modalNum: number;
  title: string;
  content: string;
  footer: string;
  imgUrl: string;
  addImgUrl1: string;
  addImgUrl2: string;
  addImgUrl3: string;
  url1: string;
  url2: string;
  url3: string;
}) => {
  const dispatch = useDispatch();

  return (
    <Background modalNum={modalNum}>
      <div
        style={{ width: "767px" }}
        className="p-32 max-h-[80vh] overflow-auto bg-white pretty-scrollbar"
      >
        <div
          onClick={() => dispatch(modalToggle(modalNum))}
          className="flex justify-end cursor-pointer"
        >
          <ModalX />
        </div>
        <div className="max-w-[767px] p-16">
          {imgUrl ? (
            <>
              <img className="h-100" src={imgUrl} alt="서비스배너" />
            </>
          ) : null}
          <hr className="mt-20 mb-20 border-[#EF7443] border-2" />
          <span className="font-bold text-24">{parse(title)}</span>
          <hr className="mt-20 mb-20" />
          <Quill
            readOnly
            value={content}
            className="plane_quill"
            toolbar={false}
          />
          <hr className="mt-20 mb-20 border-2 border-black" />
          {addImgUrl1 ? (
            <a href={url1}>
              <img src={addImgUrl1} alt="배너" className="mb-10 h-120"></img>
            </a>
          ) : (
            <></>
          )}
          {addImgUrl2 ? (
            <a href={url2}>
              <img src={addImgUrl2} alt="배너" className="mb-10 h-120"></img>
            </a>
          ) : (
            <></>
          )}
          {addImgUrl3 ? (
            <a href={url3}>
              <img src={addImgUrl3} alt="배너" className="mb-10 h-120"></img>
            </a>
          ) : (
            <></>
          )}

          <p className="text-[#989898] text-14">
            본 메일은 광고성 정보전송에 대한 정보통신망 발굴 등 관련규정에
            <br /> 의거하여 발송되었습니다.
          </p>
          <hr className="mt-20 mb-10" />
          <Quill
            readOnly
            value={footer}
            className="plane_quill"
            toolbar={false}
          />

          <hr className="mt-20 mb-10" />

          <div className="flex items-center">
            <p>내 문의 내역과 진행사항을 확인하고 싶다면?</p>
            <div className="w-20"></div>
            <a
              className="text-white no-underline "
              href="${config.endpoint.web}/member/login?serviceNo=${serviceNo}&userId=${userId}"
            >
              <div className="w-130 h-40 bg-[#1c274c] rounded-lg text-center">
                <span className="font-bold leading-40">통합회원 가입 </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </Background>
  );
};

export default PreviewAutoMailModal;
